import Marquee from "react-fast-marquee";
import { useLang } from "@/i18n/LanguageContext";

export const EditorialMarquee = () => {
  const { t } = useLang();
  const ITEMS = t.marquee;
  return (
    <div className="relative border-y border-white/10 bg-black/50 py-6 md:py-8 overflow-hidden" data-testid="editorial-marquee">
      <Marquee speed={26} gradient gradientColor="#0a0a0a" gradientWidth={120}>
        {ITEMS.map((item, i) => (
          <div key={i} className="flex items-center">
            <span className="marquee-item font-extrabold tracking-tight text-2xl md:text-4xl text-white/90 px-8">
              {item}
            </span>
            <span className="text-[var(--al-gold)] text-2xl md:text-4xl">◦</span>
          </div>
        ))}
      </Marquee>
    </div>
  );
};
